import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_10 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_11 = { class: "text-center mt-5" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!
  const _component_provider_garment_productions_table = _resolveComponent("provider-garment-productions-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Suggestion Filters",
          text: "Suggestion Filters"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_form_field, {
            type: "select",
            labelKey: "Keep using my raw materials",
            labelValue: "Keep using my raw materials",
            placeholderKey: "Keep using my raw materials",
            placeholderValue: "Keep using my raw materials",
            list: _ctx.yesOrNoSelect,
            modelValue: _ctx.keepUsingEstimationRawMaterialsString,
            "onUpdate:modelValue": _ctx.keepUsingEstimationRawMaterialsUpdated
          }, null, 8, ["list", "modelValue", "onUpdate:modelValue"])
        ]),
        (_ctx.keepUsingEstimationRawMaterialsString == false.toString() && _ctx.showGSMSuggestion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_form_field, {
                type: "select",
                labelKey: "Keep using my GSM",
                labelValue: "Keep using my GSM",
                placeholderKey: "Keep using my GSM",
                placeholderValue: "Keep using my GSM",
                list: _ctx.yesOrNoSelect,
                modelValue: _ctx.keepUsingEstimationGSMString,
                "onUpdate:modelValue": _ctx.keepUsingEstimationGSMSUpdated
              }, null, 8, ["list", "modelValue", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.keepUsingEstimationRawMaterialsString == false.toString() && _ctx.showGSMSuggestion ? 'col-sm-12' : 'col-sm-6')
        }, [
          _createVNode(_component_form_field, {
            type: "select",
            labelKey: "Use my providers",
            labelValue: "Use my providers",
            placeholderKey: "Use my providers",
            placeholderValue: "Use my providers",
            list: _ctx.yesOrNoSelect,
            modelValue: _ctx.useProvidersString,
            "onUpdate:modelValue": _ctx.useProvidersUpdated
          }, null, 8, ["list", "modelValue", "onUpdate:modelValue"])
        ], 2)
      ]),
      (_ctx.useProvidersString == true.toString())
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("p", null, [
              _createVNode(_component_localized_text, {
                type: "strong",
                localizedKey: "Available Providers",
                text: "Available Providers"
              })
            ]),
            (_ctx.providers.length > 0)
              ? (_openBlock(), _createBlock(_component_provider_garment_productions_table, {
                  key: 0,
                  garmentProductions: _ctx.providers,
                  showCTAs: false
                }, null, 8, ["garmentProductions"]))
              : (_openBlock(), _createBlock(_component_localized_text, {
                  key: 1,
                  localizedKey: "You don't have any provider for this garment",
                  text: "You don't have any provider for this garment"
                }))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.disabled)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-tertiary me-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addProvider()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Add a provider",
                text: "Add a provider"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.applyFilters()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Apply",
            text: "Apply"
          })
        ], 8, _hoisted_12)
      ])
    ])
  ]))
}